import { parseNumber } from "../services/currencyService.js";
import { resolveUsdIlsRateNumber } from "./orders/formatOrderPrice.js";

export const NAME_CHANGE_FEE_USD = 40;
export const NAME_CHANGE_PAYMENT_REASON = "passenger_name_change";
export const NAME_CHANGE_EXCHANGE_SOURCE = "current_system_rate";
/** תיאור העסקה (שדה Info) ביעד שריג לדמי שינוי שם */
export const NAME_CHANGE_HYP_TRANSACTION_DESCRIPTION = "שינוי שם";

/**
 * חישוב דמי שינוי שם: שער מועדף מ־AppContext (אדמין/API), או מ־localStorage (בורר מטבע).
 * @param {number|string|null|undefined|(() => unknown)} [rateInput] - למשל currencyRate.USD; תומך גם בפונקציה (בדיקות ישנות).
 * @returns {{ amountUsd: number, exchangeRateUsed: number|null, amountIls: number|null, exchangeRateSource: string }}
 */
export function computePassengerNameChangePayment(rateInput) {
  let rateNum = null;
  if (typeof rateInput === "function") {
    const raw = rateInput();
    const fromFn =
      raw != null && raw !== "" && String(raw) !== "undefined"
        ? parseFloat(String(raw))
        : NaN;
    rateNum =
      Number.isFinite(fromFn) && fromFn > 0 ? fromFn : resolveUsdIlsRateNumber(undefined);
  } else {
    rateNum = resolveUsdIlsRateNumber(rateInput);
  }
  const amountUsd = NAME_CHANGE_FEE_USD;
  if (rateNum == null || !Number.isFinite(rateNum) || rateNum <= 0) {
    return {
      amountUsd,
      exchangeRateUsed: null,
      amountIls: null,
      exchangeRateSource: NAME_CHANGE_EXCHANGE_SOURCE,
    };
  }
  const amountIls = Math.round(amountUsd * rateNum * 100) / 100;
  return {
    amountUsd,
    exchangeRateUsed: rateNum,
    amountIls,
    exchangeRateSource: NAME_CHANGE_EXCHANGE_SOURCE,
  };
}

/**
 * @param {object} p
 */
export function logNameChangePaymentTraceDev(p) {
  if (!import.meta.env?.DEV) return;
  console.log("[OP_REQUEST_NAME_CHANGE_PAYMENT_TRACE]", p);
}

/**
 * @param {Record<string, unknown>} sel
 * @param {string} newFirst
 * @param {string} newLast
 * @param {number|null} amountUsd
 * @param {number|null} rate
 * @param {number|null} amountIls
 * @param {string} [extraNotes]
 */
export function buildNameChangeOperationMessage(sel, newFirst, newLast, amountUsd, rate, amountIls, extraNotes = "") {
  const display = String(sel?.displayName ?? "—");
  const oldF = String(sel?.oldFirstName ?? "").trim();
  const oldL = String(sel?.oldLastName ?? "").trim();
  const parts = [
    "שינוי שם נוסע (פנייה לאופרציה):",
    `נוסע נבחר: ${display}`,
    `שם נוכחי (פרטי / משפחה): ${oldF || "—"} / ${oldL || "—"}`,
    `שם חדש (פרטי / משפחה): ${newFirst.trim()} / ${newLast.trim()}`,
  ];
  if (amountUsd != null && Number.isFinite(amountUsd)) {
    let feeLine = `עלות טיפול שינוי שם: ${parseNumber(amountUsd)}$`;
    if (rate != null && amountIls != null && Number.isFinite(rate) && Number.isFinite(amountIls)) {
      feeLine += ` · שער יציג ${rate} · סה״כ ≈ ${parseNumber(amountIls)} ₪`;
    }
    parts.push(feeLine);
  }
  const notes = String(extraNotes ?? "").trim();
  if (notes) parts.push("", "הערות נוספות:", notes);
  return parts.join("\n");
}
